import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';
import liwazaLogo from '../assets/liwaza-logo.png';
import './Authentication.css';
import { API_BASE_URL, toastdisplay } from '../utils/utils';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({
    show: false,
    message: '',
    success: true,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const resetToken = params.get('token');

    if (!resetToken) {
      toastdisplay(
        'Invalid or expired password reset link.',
        false,
        3000,
        setToast
      );
    } else {
      setToken(resetToken);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = {};

    if (!password || password.length < 8) {
      formErrors.password = 'Password must be at least 8 characters.';
    }

    if (!confirmPassword || password !== confirmPassword) {
      formErrors.confirmPassword = 'Passwords do not match.';
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();
      if (!response.ok) {
        toastdisplay(data.detail || 'Reset failed', false, 2000, setToast);
        throw new Error(data.detail || 'Reset failed');
      }

      toastdisplay(
        'Password reset successfully! Redirecting...',
        true,
        2000,
        setToast
      );
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      toastdisplay(
        err.message || 'Error resetting password.',
        false,
        2000,
        setToast
      );
    }
  };

  return (
    <div className="liwaza-layout">
      <div style={{ width: '100%', maxWidth: 400, marginBottom: 8 }}>
        <img
          src={liwazaLogo}
          alt="Liwaza Logo"
          style={{ height: '32px', cursor: 'pointer' }}
          onClick={() => navigate('/login')}
        />
      </div>

      <form className="liwaza-form" onSubmit={handleSubmit}>
        <h1 className="liwaza-title">Reset your password</h1>
        <p className="liwaza-subtitle">
          Enter a new password to access your account again.
        </p>

        <div className="liwaza-field">
          <label>New password</label>
          <div className="liwaza-input-wrapper">
            <FiLock className="liwaza-icon" />
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {errors.password && (
            <div className="text-danger" style={{ fontSize: 13 }}>
              {errors.password}
            </div>
          )}
        </div>

        <div className="liwaza-field">
          <label>Confirm new password</label>
          <div className="liwaza-input-wrapper">
            <FiLock className="liwaza-icon" />
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          {errors.confirmPassword && (
            <div className="text-danger" style={{ fontSize: 13 }}>
              {errors.confirmPassword}
            </div>
          )}
        </div>

        <button type="submit" className="btn-lwz-primary">
          Reset password
        </button>
        <button
          type="button"
          className="btn-lwz-outline"
          onClick={() => navigate('/login')}
        >
          Back to login
        </button>
      </form>

      <div style={{ marginTop: '16px', textAlign: 'center' }}>
        <a href="/terms" className="liwaza-legal-link">
          Terms and conditions
        </a>
      </div>

      {toast.show && (
        <div
          className={`toast-notification ${toast.success ? 'success' : 'error'}`}
        >
          <span className="toast-icon">{toast.success ? '✔️' : '❌'}</span>
          <span>{toast.message}</span>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
